<template>
  <div class="upload">
    <el-select v-model="selectvalue" filterable placeholder="请选择人员" class="select" @change="clickchange">
       <el-option
         v-for="item in erpuserneibulist" :key="item.Id" :label="item.Name" :value="item.Id">
       </el-option>
    </el-select>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      action: '',
      selectvalue: '',
      erpuserneibulist: [],
      selectmultiuser: []
    }
  },
  mounted () {
    this.apigeterpuserneibulist()
  },
  methods: {
    clickchange (rv) {
      this.$emit('change',rv)
    },
    apigeterpuserneibulist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpuserneibulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.erpuserneibulist = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
  display: inline-block;
}
// /deep/ .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
// }
// /deep/ .el-upload:hover {
//     border-color: #409EFF;
// }

.upload{
    // display: inline-block;
    margin-left: 0px;
}
</style>
